import React from 'react';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import BuildIcon from '@mui/icons-material/Build';
import PersonIcon from '@mui/icons-material/Person';
import SecurityIcon from '@mui/icons-material/Security';
import ThreatModelingModule from './threatModeling/ThreatModelingModule.tsx';
import DoraModule, { doraTabs } from './dora/DoraModule.tsx';
import type { OrganizationWithRole } from '../api.ts';

export const MODULE_STORAGE_KEY = 'currentModule';

export type ModuleFlag = 'threat_modeling_enabled' | 'dora_enabled';

export interface ModuleNavItem {
  label: string;
  path: string;
  icon: React.ElementType;
}

export interface ModuleRouteConfig {
  path: string;
  element: React.ReactNode;
}

export interface ModuleDefinition {
  id: string;
  name: string;
  flag: ModuleFlag;
  navItems: ModuleNavItem[];
  routes: ModuleRouteConfig[];
}

export const MODULES: ModuleDefinition[] = [
  {
    id: 'threat_modeling',
    name: 'Threat Modeling',
    flag: 'threat_modeling_enabled',
    navItems: [
      { label: 'Risks', path: '/risks', icon: WarningAmberIcon },
      { label: 'Mitigations', path: '/mitigations', icon: BuildIcon },
      { label: 'Actors', path: '/actors', icon: PersonIcon },
    ],
    routes: [
      { path: '/risks', element: <ThreatModelingModule /> },
      { path: '/mitigations', element: <ThreatModelingModule /> },
      { path: '/actors', element: <ThreatModelingModule /> },
    ],
  },
  {
    id: 'dora',
    name: 'DORA',
    flag: 'dora_enabled',
    navItems: doraTabs.map(tab => ({
      label: tab.label,
      path: tab.path,
      icon: tab.icon || SecurityIcon,
    })),
    routes: [
      { path: '/dora', element: <DoraModule /> },
      ...doraTabs.map(tab => ({
        path: tab.path,
        element: <DoraModule initialTabId={tab.id} />,
      })),
    ],
  },
];

export const getAvailableModules = (
  organization?: OrganizationWithRole | null,
): ModuleDefinition[] => {
  if (!organization) {
    return [];
  }

  return MODULES.filter(module => Boolean(organization[module.flag]));
};

export const getModuleById = (moduleId?: string | null): ModuleDefinition | null => {
  if (!moduleId) {
    return null;
  }

  return MODULES.find(module => module.id === moduleId) ?? null;
};
